export default __webpack_public_path__ + "static/media/sales-management-img-ar.92b20f05.png";